module.exports = __webpack_public_path__ + "img/cancel.b5c55289.svg";